import React from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { ResearchForm, type ResearchFormData } from './ResearchForm';
import type { VenueResearch } from '@/services/VenueResearchService';
import type { DestinationWithCount } from '@/services/ResearchService';

// Re-export for convenience
export type { ResearchFormData };

export interface ResearchFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: ResearchFormData) => Promise<void>;
  isSubmitting?: boolean;
  initialValues?: Partial<ResearchFormData>;
  activeResearchJobs?: VenueResearch[];
  destinations?: DestinationWithCount[];
}

export function ResearchFormModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
  initialValues,
  activeResearchJobs = [],
  destinations = [],
}: ResearchFormModalProps) {
  const handleSubmit = async (data: ResearchFormData) => {
    await onSubmit(data);
    // Don't close automatically - let parent handle it
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Research More Venues"
      description="Schedule AI-powered research jobs to discover additional venues matching your criteria"
      size="xl"
    >
      <ResearchForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        initialValues={initialValues}
        hideHeader={true}
        activeResearchJobs={activeResearchJobs}
      />
    </Modal>
  );
}

